import { ERequestApiStatus } from './appState';
import { TRoute } from './route';
import { IChatDataInListSchema, EType } from '../repositories/chats/entities/chat/ChatDataInListSchema';

// Количество чатов на 1 страницу
const CHATS_ON_PAGE_LIMIT = 25;

type TChatInListSchema = IChatDataInListSchema & {
  data?: any;
};

type TChatListState = {
  status: ERequestApiStatus;
  currentPage: number;
  currentRoute: TRoute;
  chats: TChatInListSchema[];
  allChatsLoaded?: boolean;
  timestamp?: number;
  timestampSpam?: number;
  timestampArchive?: number;
  movedToSpamChatIds: string[];
  removedFromSpamChatId?: string;
  movedToArchiveChatIds: string[];
  removedFromArchiveChatId?: string;
  notClearCurrentOpenedChatId?: boolean;
  isChangeListActive: boolean;
  selectedChats: string[];
};

export { CHATS_ON_PAGE_LIMIT, EType as EChatInListType, TChatInListSchema, TChatListState };
